import { render } from "./ListadoRouters.vue?vue&type=template&id=005cb110&scoped=true"
import script from "./ListadoRouters.vue?vue&type=script&lang=js"
export * from "./ListadoRouters.vue?vue&type=script&lang=js"

import "./ListadoRouters.vue?vue&type=style&index=0&id=005cb110&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-005cb110"]])

export default __exports__